import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Container from 'components/Container';
import Button from 'components/Button';
import ContactForm from 'components/ContactForm';
import LottieAnimation from 'components/LottieAnimation';
import robotHeroAnimation from 'assets/animations/robot-hero.json';

import {
  Section,
  InnerContainer,
  HeroText,
  HeroDescription,
  Content,
  AnimationWrapper,
  ButtonStyles,
} from './Hero.styles';

const Hero = () => {
  const [t] = useTranslation('global');
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <Section id="hero">
        <Container>
          <InnerContainer>
            <Content>
              <HeroText>{t('hero.leading')}</HeroText>
              <HeroDescription>{t('hero.description')}</HeroDescription>
              <Button
                styles={ButtonStyles}
                onClick={() => setIsContactOpen(true)}
              >
                {t('header.contact')}
              </Button>
            </Content>
            <AnimationWrapper>
              <LottieAnimation
                animationData={robotHeroAnimation}
                width="100%"
                height="100%"
                loop
                autoplay
                rendererSettings={{
                  preserveAspectRatio: 'xMidYMid meet',
                  progressiveLoad: false,
                }}
              />
            </AnimationWrapper>
          </InnerContainer>
        </Container>
      </Section>
      <ContactForm
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />
    </>
  );
};

export default Hero;
